import PropTypes from 'prop-types';

export default {
  isCallInprogress: PropTypes.bool,
  applications: PropTypes.shape({
    totalElements: PropTypes.number,
    page: PropTypes.number,
    records: PropTypes.arrayOf(PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
      completedDate: PropTypes.string,
      status: PropTypes.string,
    })),
  }),
};
